export class RestrictionsRequestQueryData {
    name: string;
    queryAttributes: string[];
}

export class RestrictionsRequestData {
    cubeName: string;
    dashboardAttributes: string[];
    dateRangeRef: string;
    queries: RestrictionsRequestQueryData[];
}
